export default __webpack_public_path__ + "static/media/hht1_quiztime.7e8a856e.png";